module.exports = __webpack_public_path__ + "static/media/aghahi.f7f4ede6.png";